import { addNamesToTabs, processArray, findNode, checkRouteMatch, replaceMatchedRoute } from '@/view/pages/components/index.js'

export default {
    loginBegin(state) {
        state.loading = true;
    },
    loginSuccess(state, data,) {
        state.loading = false;
        state.login = data.login;
        state.super_login = data.super_login;
    },

    loginErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    logoutBegin(state) {
        state.loading = true;
    },

    logoutSuccess(state, data) {
        state.loading = false;
        state.login = data;
        state.super_login = false;
    },

    logoutErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    menuData(state, data) {
        state.menuData = data;
    },

    websiteMenuData(state, data) {
        state.website_menu_data = data;
    },
    someMutation(state, lang) {
        state.site_lang = lang;
    },
    setCollapsed(state, payload) {
        state.collapsed = payload;

    },
    superToken(state, payload) {
        state.super_token = payload;
    },
    siteListFnc(state, payload) {
        state.site_list = payload;
    },
    alearTabsList(state) {
        // 主要适用于没有退出，但是token值变化的情况下，设置默认值，清除页签
        state.tabsList = []
    },
    SET_REFRESH_FLAG(state, path) {
        state.refreshFlags[path] = Date.now() // 用时间戳作为标记，确保每次变化
    },
    // 只保留首页，其余全部删除
    lastTabsList(state) {
        // 主要适用于没有退出，但是token值变化的情况下，设置默认值，清除页签
        state.tabsList = [{ path: "/", title: "", id: "网站概况", name: "网站概况", meta: { auth: false } }]
    },
    // tab页签删除左侧
    leftDelTab(state, payload) {
        const targetIndex = payload.data.findIndex(item => item.id === payload.id)
        if (targetIndex === -1) return
        state.tabsList = [
            payload.data[0],
            ...payload.data.slice(targetIndex)
        ]
    },
    // tab页签删除右侧
    rightDelTab(state, payload) {
        const targetIndex = payload.data.findIndex(item => item.id === payload.id)
        if (targetIndex === -1) return
        state.tabsList = payload.data.slice(0, targetIndex + 1)
    },
    // tab页签删除其他
    otherDelTab(state, payload) {
        state.tabsList = [
            payload.data[0],
            ...payload.data.filter(item => item.id === payload.id)
        ]

    },
    siteDataFnc(state, payload) {
        state.siteData = payload;
    },
    ADD_TABS_LIST(state, payload) {
        if (state.tabsList.some(v => v.path === payload.path)) return
        const pathArray = processArray(payload.path);
        const camelCaseTitle = pathArray
            .filter(segment => segment) // 过滤空字符串
            .map((segment, index) => {
                if (index === 0) {
                    return segment; // 第一个片段首字母小写
                } else {
                    // 后续片段首字母大写，其余字母小写
                    return segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase();
                }
            }).join('');
        if (payload.meta.true_id) {
            const menuItem = findNode(state.menuData, payload.meta.true_id);
            if (menuItem && menuItem.menu_type == 2) {
                payload.menu_type = 2; // 添加menu_type属性
            }
        }
        const idShowIndex = state.tabsList.findIndex(val => val.id === payload.meta.true_id);

        if (idShowIndex === -1 && !payload.menu_type) {
            state.tabsList.push({
                path: payload.path,
                title: camelCaseTitle,
                id: payload.name,
                name: payload.name,
                meta: { ...payload.meta },
            });
        } else if (payload.menu_type === 2 && idShowIndex !== -1) {
            state.tabsList[idShowIndex] = {
                path: payload.path,
                title: camelCaseTitle,
                id: payload.name,
                name: payload.name,
                meta: { ...payload.meta },
            };
        } else if (idShowIndex === -1 && payload.menu_type == 2 && checkRouteMatch(state.tabsList, payload)) {
            const params = JSON.parse(JSON.stringify(state.tabsList))
            state.tabsList = replaceMatchedRoute(params, payload)
        } else {
            state.tabsList.push({
                path: payload.path,
                title: camelCaseTitle,
                id: payload.name,
                name: payload.name,
                meta: { ...payload.meta },
            });
        }
        state.tabsList = addNamesToTabs(state.tabsList, state.menuData)

    },
    SET_TABS_LIST(state, path) {
        state.activeTab = path
    },
    DEL_TABS_LIST(state, payload) {
        state.tabsList = state.tabsList.filter(tab => tab.path !== payload.path);
    }
};

